module.exports = __webpack_public_path__ + "img/switch-role-bg-huo.32f26a37.png";